<script>
    import MBaseFormElement from "@/assets/plugins/mps-form/providers/MBaseFormElement";

    export default {
        name: "MBaseFormPicker",
        extends: MBaseFormElement
    }
</script>
